export default function (dom, opts) {
    let options = {
        ...opts
    };

    const html = document.documentElement;
    const filterList = document.querySelector(".family-products__list--rows")
    //const filterBtn = dom.querySelector("[data-filter-btn]")
    const widthMin = dom.querySelector("[name=width-min]");
    const widthMax = dom.querySelector("[name=width-max]");
    const heightMin = dom.querySelector("[name=height-min]");
    const heightMax = dom.querySelector("[name=height-max]");
    const bottomMin = dom.querySelector("[name=bottom-min]");
    const bottomMax = dom.querySelector("[name=bottom-max]");
    const allProducts = document.querySelectorAll(".family-products__product");
    const noProducts = document.querySelector("[data-no-products]");
    const resetFilter = dom.querySelector("[data-reset]");
    const showAll =  document.querySelector("[data-show-all]");
    const intersection = document.querySelector(".product-intersection");
    const maxProducts  = 50;
    let filtered = false;

    function init() {
        showAll.style.display = 'none';
        intersection.style.display = 'none';

        /* show all Products */
        if(showAll){
            showAll.addEventListener('click', function(e){
                allProducts.forEach(function (element) {
                    if(element.classList.contains("hidden")) {
                        element.classList.add("show");
                    }
                    showAll.style.display = 'none';
                });
            })
        }

        /* reset filter */
        resetFilter.addEventListener('click', function(e){
            allProducts.forEach(function (element) {
                /* reset */
                element.removeAttribute("data-match-width");
                element.removeAttribute("data-match-height");
                element.removeAttribute("data-match-bottom");
                element.classList.remove("show");
            });

            filterList.classList.remove('filtered');
            
            if (showAll) {
                showAll.style.display = 'block';
                intersection.style.display = 'none';
            }

            widthMin.value = '';
            widthMax.value = '';
            heightMin.value = '';
            heightMax.value = '';
            bottomMin.value = '';
            bottomMax.value = '';
        });

       /* search for correct products */
       /* filterBtn.addEventListener('click', function(e) {
            doFilter();
        });*/
        widthMin.addEventListener('input', function(e) { doFilter()});
        widthMax.addEventListener('input', function(e) { doFilter()});
        heightMin.addEventListener('input', function(e) { doFilter()});
        heightMax.addEventListener('input', function(e) { doFilter()});
        bottomMin.addEventListener('input', function(e) { doFilter()});
        bottomMax.addEventListener('input', function(e) { doFilter()});

    }

    function doFilter(){
        //console.info("minwith", widthMin.value, "widthmax", widthMax.value);

        allProducts.forEach(function (element) {

            /* set filtered flag */
            filtered = true;

            /* reset */
            element.removeAttribute("data-match-width");
            element.removeAttribute("data-match-height");
            element.removeAttribute("data-match-bottom");
            element.classList.remove("show");
            element.classList.remove("showall");
            noProducts.style.display = 'none';
            showAll.style.display = 'none';
            intersection.style.display = 'none';

            /* breite */
            if (widthMin.value || widthMax.value) {
                element.setAttribute("data-match-width", "false");
            }

            if(null !== element.getAttribute("data-breite")) {
                let searchWidth = Number(element.getAttribute("data-breite"));
                
                /* min */
                if (widthMin.value > 0 && (!widthMax.value || widthMax.value == 0) && searchWidth >= widthMin.value) {
                    element.setAttribute("data-match-width", "true");
                }

                /* max */
                console.info(searchWidth);
                if ((!widthMin.value || widthMin.value == 0) && widthMax.value > 0 && searchWidth <= widthMax.value) {
                    element.setAttribute("data-match-width", "true");
                }

                /* minmax or same */
                if (!element.getAttribute("data-flexwidth")) {
                    if (widthMin.value > 0 && widthMax.value > 0 && searchWidth >= widthMin.value && searchWidth <= widthMax.value) {
                        element.setAttribute("data-match-width", "true");
                    }
                } else {
                    if (widthMin.value > 0 && widthMax.value > 0) {
                       /* if division by multiplier is within minimum+ range, set true */
                       let rest = widthMin.value % searchWidth;
                       console.info(searchWidth,rest);
                       if(Number(widthMin.value) + rest <= widthMax.value || searchWidth == widthMax.value) {
                            element.setAttribute("data-match-width", "true");
                       }
                    }
                }
            }

            /* höhe */
            if (heightMin.value || heightMax.value) {
                element.setAttribute("data-match-height", "false");
            }

            if(null !== element.getAttribute("data-hoehe")) {
                let searchHeight = Number(element.getAttribute("data-hoehe"));
                
                /* min */
                if (heightMin.value > 0 && (!heightMax.value || heightMax.value == 0) && searchHeight >= heightMin.value) {
                    element.setAttribute("data-match-height", "true");
                }

                /* max */
                if ((!heightMin.value || heightMin.value == 0) && heightMax.value > 0 && searchHeight <= heightMax.value) {
                    element.setAttribute("data-match-height", "true");
                }

                /* minmax or same */
                if (heightMin.value > 0 && heightMax.value > 0 && searchHeight >= heightMin.value && searchHeight <= heightMax.value) {
                    element.setAttribute("data-match-height", "true");
                }
            }

            /* Boden */
            if (bottomMin.value || bottomMax.value) {
                element.setAttribute("data-match-bottom", "false");
            }

            if(null !== element.getAttribute("data-boden")) {
                let searchBottom = Number(element.getAttribute("data-boden"));
                
                /* min */
                if (bottomMin.value > 0 && (!bottomMax.value || bottomMax.value == 0) && searchBottom >= bottomMin.value) {
                    element.setAttribute("data-match-bottom", "true");
                }

                /* max */
                if ((!bottomMin.value || bottomMin.value == 0) && bottomMax.value > 0 && searchBottom <= bottomMax.value) {
                    element.setAttribute("data-match-bottom", "true");
                }

                /* minmax or same */
                if (bottomMin.value > 0 && bottomMax.value > 0 && searchBottom >= bottomMin.value && searchBottom <= bottomMax.value) {
                    element.setAttribute("data-match-bottom", "true");
                }
            }
        });

        filterList.classList.add('filtered');

        /* display control of all Products Button */
        if (getAllVisible(allProducts).length == 0) {
            noProducts.style.display = 'block';
        } else {
            if (getAllVisible(allProducts, true).length > 0) {
                showAll.style.display = 'block';
                intersection.style.display = 'block';
            } else {
                showAll.style.display = 'none';
                intersection.style.display = 'none';
            }
        }
        
    }

    function getAllVisible(list, elh = false) {
        let allVisible = [];

        list.forEach(function (element) {
            
            if(element.getAttribute("data-match-width") !== 'false' && element.getAttribute("data-match-height") !== 'false' && element.getAttribute("data-match-bottom") !== 'false') {
                if(elh) {
                    if(element.classList.contains("hidden")) {
                        allVisible.push(element);
                    }
                } else {
                    allVisible.push(element);
                }
            }
        });

        return allVisible;
    }

    init();

}
